import React from 'react';

const LeftAds = ({image, id}) => {

    return (
        <div>
            <ul id="adv23"
                style={{margin: "0px auto", padding: '0px', width: '200px', height: '288px', overflow: "hidden"}}>
                      <li id="adv23_12192_1"><a href="/"><img id={id}
                    src={image} border="0" width="200" height="288" alt="phongthuy"/></a>
                </li>
              
            </ul>
            <div className="clear"/>
        </div>
    )

};

export default LeftAds;
